import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "payments-empty-state"
}
const _hoisted_2 = { class: "payments-empty-state__text" }

interface Props {
    description: string;
    loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentsEmptyState',
  props: {
    description: {},
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

/* eslint-env vue/setup-compiler-macros */


return (_ctx: any,_cache: any) => {
  return (!__props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "payments-empty-state__title" }, "No payments found", -1)),
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.description), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})